/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilSquareIcon16Solid = forwardRef('ToolPencilSquareIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 8.414V9.5a.5.5 0 0 0 .5.5h1.086a1 1 0 0 0 .707-.293L13.83 4.17l-2-2-5.538 5.538A1 1 0 0 0 6 8.414Z" }),
        React.createElement("path", { d: "M15.686 2.314 14.46 3.54l-2-2L13.686.314a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 1 0 1.414Z" }),
        React.createElement("path", { d: "M4.5 1h6.556L5.028 7.028A1.375 1.375 0 0 0 4.625 8v2c0 .76.616 1.375 1.375 1.375h2c.365 0 .714-.145.972-.403L15 4.945V11.5a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 1 11.5v-7A3.5 3.5 0 0 1 4.5 1Z" })));
});
